const Ne = (...r) => {
}, de = (r) => r.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, "\\$&"), fe = (r) => r !== null && r?.constructor.name === "Object", X = (r = "") => r.normalize("NFD").replace(/\p{Diacritic}/gu, ""), Q = (r, h) => {
  const i = r.length;
  if (!i)
    return [];
  if (fe(r[0])) {
    for (let S = 0; S < i; S++)
      if (!(h in r[S]))
        throw new Error("e03");
    return r;
  }
  return r.reduce(function(S, O) {
    return S.push({
      [h]: O && typeof O == "string" ? O : JSON.stringify(O)
    }), S;
  }, []);
}, De = (r) => r.trim().split(/\s+/), Oe = async function(r, h) {
  const i = await fetch(
    r,
    h || {
      method: "GET"
    }
  );
  return Ae(i);
}, Ae = async function(r) {
  const h = await r.text(), i = h && JSON.parse(h);
  return r.ok ? i : Promise.reject(i && i.message || r.statusText);
}, pe = {
  get: Oe
}, Fe = (r = {}) => {
  const { hasDiacritics: h } = r;
  let i = {};
  const D = "\0";
  function S(u = "") {
    return u = `${u}`, h && (u = X(u)), De(u.toLowerCase());
  }
  function O(u, p = "", m) {
    if (!u)
      return;
    let v = i, f;
    u = u.constructor === Array ? u : [u], u.forEach((y) => {
      S(typeof y == "string" ? y : y[p]).filter((L) => L).forEach((L) => {
        v = i;
        for (let C = 0, j = L.length; C < j; C++)
          f = L[C], v = v[f] || (v[f] = {});
        const k = typeof y == "string" ? y : m && m(y) || JSON.stringify(y);
        v[D] ? v[D][k] = y : v[D] = {
          [k]: y
        };
      });
    });
  }
  function R(u) {
    let p = i, m = {}, v;
    for (let L = 0, k = u.length; L < k; L++)
      if (v = u[L], p = p[v], typeof p > "u")
        return {};
    const f = [p], y = [u];
    let x;
    for (; f.length; ) {
      u = y.pop(), p = f.pop();
      for (x in p) {
        if (x === D) {
          m = Object.assign(m, p[D]);
          continue;
        }
        f.push(p[x]), y.push(u + x);
      }
    }
    return m;
  }
  function M(u, p) {
    const m = S(u), v = [];
    let f = {};
    m.forEach((x) => {
      v.push(R(x));
    }), f = v.reduce((x, L) => {
      const k = {};
      return Object.keys(x).filter((C) => L[C]).forEach((C) => {
        k[C] = x[C];
      }), k;
    }), f = Object.values(f);
    const y = f.length;
    return p && y > p && (f.length = p), {
      suggestions: f,
      count: y
    };
  }
  function s() {
    i = {};
  }
  return {
    add: O,
    clear: s,
    search: M
  };
};
function $e(r) {
  if (!r.input)
    throw new Error("e01");
  if (!fe(r.source))
    throw new Error("e02");
  const h = document, i = h.createElement("div"), D = r.debounceRemote || 100, S = r.preventSubmit || !1, O = r.minLength || 1, R = r.hint !== !1, M = r.autoSelect || !1, s = r.templates, u = Fe({ hasDiacritics: r.diacritics }), p = r.source.identifier || "label", m = r.source.groupIdentifier || "", v = (e) => `${e[p]}`, f = r.display || v, y = r.source.identity || v, x = r.onSubmit || Ne, L = r.source.dataTokens?.constructor === Array ? r.source.dataTokens : void 0, k = r.source.transform || ((e) => e), C = r.source.local || null, j = typeof r.source.remote?.url, N = j === "function" || j === "string" && r.source.remote.wildcard ? r.source.remote : null, T = r.source.prefetch?.url ? { when: "onInit", done: !1, ...r.source.prefetch } : null, g = {
    wrapper: "",
    input: "tt-input",
    hint: "tt-hint",
    highlight: "tt-highlight",
    hide: "tt-hide",
    show: "tt-show",
    list: "tt-list",
    selected: "tt-selected",
    header: "tt-header",
    footer: "tt-footer",
    loader: "tt-loader",
    suggestion: "tt-suggestion",
    group: "tt-group",
    empty: "tt-empty",
    notFound: "tt-notFound",
    ...r.classNames || {}
  };
  if (!C && !T && !N)
    throw new Error("e02");
  const n = {
    query: "",
    items: [],
    // suggestions
    count: 0,
    limit: r.limit || 5
  };
  let P = {}, z = {}, d, U, I = !1, W = "";
  s && (s.header = typeof s.header == "function" ? s.header : void 0, s.footer = typeof s.footer == "function" ? s.footer : void 0, s.notFound = typeof s.notFound == "function" ? s.notFound : void 0, s.group = typeof s.group == "function" ? s.group : void 0, s.suggestion = typeof s.suggestion == "function" ? s.suggestion : void 0, s.loader = typeof s.loader == "function" ? s.loader : void 0, s.empty = typeof s.empty == "function" ? s.empty : void 0);
  const V = (e = []) => {
    te(Q(e, p));
  };
  C && V(C);
  const c = r.input;
  c.classList.add(g.input);
  const ne = window.getComputedStyle(c), H = h.createElement("div");
  H.className = `typeahead-standalone${r.className ? ` ${r.className}` : ""}${g.wrapper ? ` ${g.wrapper}` : ""}`, n.container = H;
  const B = c.parentNode, he = [...B.children].indexOf(c);
  B.removeChild(c), H.appendChild(c), B.insertBefore(H, B.children[he]);
  const J = c.cloneNode();
  R && xe(J), i.classList.add(g.list, g.hide), i.tabIndex = 0, i.setAttribute("aria-label", "menu-options"), i.setAttribute("role", "listbox"), i.style.position = "absolute", i.style.width = `${c.offsetWidth}px`, i.style.marginTop = `${c.offsetHeight + parseInt(ne.marginTop)}px`, H.appendChild(i), T && T.when === "onInit" && re();
  function re() {
    if (!T || T.done)
      return;
    let e = [];
    pe.get(typeof T.url == "function" ? T.url() : T.url, T?.requestOptions).then(
      (t) => {
        e = k(t), e = Q(e, p), te(e);
      },
      (t) => {
        console.error("e04", t);
      }
    ).finally(() => {
      typeof T.process == "function" && T.process(e);
    }), T.done = !0;
  }
  const Y = () => {
    i.classList.remove(g.hide);
  }, me = () => {
    i.classList.add(g.hide);
  }, ge = () => !i.classList.contains(g.hide), oe = () => {
    U && window.clearTimeout(U);
  }, A = () => {
    n.items = [], J.value = "", W = "", me();
  }, se = () => {
    c.dispatchEvent(
      new InputEvent("input", {
        bubbles: !0,
        inputType: "insertCompositionText",
        data: c.value
      })
    );
  }, K = (e = !1) => {
    if (!n.items.length && n.query) {
      A(), Z();
      const t = s?.notFound && s.notFound(n);
      if (!t)
        return !0;
      const o = (E) => {
        const l = h.createElement("div");
        l.classList.add(g.notFound), F(l, E), i.appendChild(l);
      };
      return N ? (P[JSON.stringify(n.query)] || e && !I) && o(t) : o(t), Y(), !0;
    }
  }, Z = () => {
    for (; i.firstChild; )
      i.firstChild.remove();
  }, ie = () => {
    if (!s?.loader)
      return;
    if (!I) {
      const t = i.querySelector(`.${g.loader}`);
      t && i.removeChild(t);
      return;
    }
    const e = h.createElement("div");
    e.classList.add(g.loader), F(e, s.loader()), s?.footer ? i.insertBefore(e, i.querySelector(`.${g.footer}`)) : i.appendChild(e);
  }, G = () => {
    if (K())
      return;
    Z();
    const e = (l) => {
      const a = h.createElement("div");
      return a.classList.add(g.suggestion), a.setAttribute("role", "option"), a.setAttribute("aria-selected", "false"), a.setAttribute("aria-label", f(l)), s?.suggestion ? F(a, s.suggestion(l, n)) : a.textContent = l[p] || "", a;
    }, t = (l) => {
      const a = h.createElement("div");
      return a.classList.add(g.group), a.setAttribute("role", "group"), a.setAttribute("aria-label", l), s?.group ? F(a, s.group(l, n)) : a.textContent = l || "", a;
    }, o = h.createDocumentFragment(), E = [];
    if (s?.header) {
      const l = h.createElement("div");
      l.classList.add(g.header), l.setAttribute("role", "presentation"), F(l, s.header(n)) && o.appendChild(l);
    }
    for (const [l, a] of n.items.entries()) {
      if (l === n.limit)
        break;
      if (a[m] && !E.includes(a[m])) {
        E.push(a[m]);
        const w = t(a[m]);
        o.appendChild(w);
      }
      const b = e(a);
      b.addEventListener("click", (w) => {
        A(), d = a, c.value = f(a, w), se();
      }), a === d && (b.classList.add(g.selected), b.setAttribute("aria-selected", "true")), o.appendChild(b), r.highlight && Le(b, n.query);
    }
    if (s?.footer) {
      const l = h.createElement("div");
      l.classList.add(g.footer), l.setAttribute("role", "presentation"), F(l, s.footer(n)) && o.appendChild(l);
    }
    i.appendChild(o), R && Se(d || n.items[0]), i.querySelector(`.${g.selected}`)?.scrollIntoView({ block: "nearest" }), Y();
  }, ye = (e) => {
    typeof e.inputType > "u" || e.inputType === "insertCompositionText" && !e.isComposing || (W = c.value, le());
  }, Ee = (e) => {
    const t = n.items.length >= n.limit ? n.limit : n.items.length;
    if (d === n.items[0]) {
      d = void 0, c.value = W;
      return;
    }
    if (!d)
      d = n.items[t - 1];
    else
      for (let o = t - 1; o > 0; o--)
        if (d === n.items[o] || o === 1) {
          d = n.items[o - 1];
          break;
        }
    c.value = f(d, e);
  }, be = (e) => {
    const t = n.items.length >= n.limit ? n.limit : n.items.length;
    if (!d) {
      d = n.items[0], c.value = f(d, e);
      return;
    }
    if (d === n.items[t - 1]) {
      d = void 0, c.value = W;
      return;
    }
    for (let o = 0; o < t - 1; o++)
      if (d === n.items[o]) {
        d = n.items[o + 1];
        break;
      }
    c.value = f(d, e);
  }, we = (e) => {
    if (e.key === "Escape" || !c.value.length && !n.items.length)
      return A();
    if (n.items.length && (e.key === "ArrowUp" || e.key === "ArrowDown")) {
      e.key === "ArrowDown" ? be(e) : Ee(e), G(), e.preventDefault(), e.stopPropagation();
      return;
    }
    const t = function(o = !1) {
      if (!d && o && n.items.length && (d = n.items[0]), d)
        return A(), c.value = f(d, e), se(), d;
    };
    if (e.key === "Enter") {
      S && e.preventDefault(), x(e, t());
      return;
    }
    e.key === "Tab" && ge() && (e.preventDefault(), t(!0));
  }, ve = () => {
    T && T.when === "onFocus" && re(), le();
  }, le = () => {
    oe();
    const e = c.value.replace(/\s{2,}/g, " ").trim();
    if (s?.empty && !e.length) {
      const t = s.empty(n);
      if (n.query = "", n.defaultItems?.length)
        return n.items = Q(n.defaultItems, p), G();
      A(), Z();
      const o = h.createElement("div");
      return o.classList.add(g.empty), F(o, t), t && i.appendChild(o), Y();
    }
    if (e.length >= O) {
      n.query = e, ee();
      const t = JSON.stringify(n.query);
      N && n.items.length < n.limit && z[t]?.length && ee(z[t]), G(), U = window.setTimeout(function() {
        n.items.length < n.limit && !I && ce();
      }, D);
    } else
      n.query = "", A();
  }, ae = (e = "") => (r.diacritics && (e = X(e)), e.toLowerCase()), ee = (e) => {
    let { suggestions: t, count: o } = u.search(n.query, n.limit);
    if (e?.length) {
      e.push(...t);
      const E = {};
      e.forEach((l) => {
        E[y(l)] = l;
      }), t = Object.values(E), o = t.length;
    }
    Te(t), m && Ce(t), n.items = t, n.count = o, d = void 0, M && n.items.length && (d = n.items[0]);
  }, ce = () => {
    if (!N)
      return;
    I = !0;
    const e = n.query, t = JSON.stringify(e);
    if (P[t] || !n.query.length) {
      I = !1, K(!0);
      return;
    }
    ie();
    let o = [];
    pe.get(
      (typeof N.url == "function" ? N.url(e) : N.url).replace(
        N.wildcard || "",
        e
      ),
      N?.requestOptions
    ).then(
      (E) => {
        o = k(E), o = Q(o, p), te(o);
      },
      (E) => {
        console.error("e05", E);
      }
    ).finally(() => {
      P[t] = !0, z[t] = o || [], I = !1, ie(), o.length && n.query.length && (ee(o), G()), n.query.length && e !== n.query && ce(), K(!0);
    });
  };
  function te(e) {
    e.length && (u.add(e, p, y), L && L.forEach((t) => {
      u.add(e, t, y);
    }));
  }
  const Te = (e) => {
    const t = n.query.toLowerCase();
    e.sort((o, E) => {
      const l = o[p].toLowerCase(), a = E[p].toLowerCase(), b = l.startsWith(t), w = a.startsWith(t);
      return b && w ? l.length - a.length : b ? -1 : w ? 1 : 0;
    });
  }, Ce = (e) => {
    e.sort((t, o) => !t[m] && !o[m] ? 0 : t[m] ? o[m] ? t[m] < o[m] ? -1 : t[m] > o[m] ? 1 : 0 : 1 : -1);
  }, Le = (e, t) => {
    const o = (b, w) => {
      const $ = de(b), q = w ? "\\b(" + $ + ")\\b" : "(" + $ + ")";
      return new RegExp(q, "i");
    }, E = (b) => {
      let w = a.exec(b.data);
      r.diacritics && !w && (w = a.exec(X(b.data)));
      const $ = h.createElement("span");
      if ($.className = g.highlight, w) {
        const q = b.splitText(w.index);
        q.splitText(w[0].length), $.appendChild(q.cloneNode(!0)), b?.parentNode?.replaceChild($, q);
      }
      return !!w;
    }, l = (b, w) => {
      let q;
      for (let _ = 0; _ < b.childNodes.length; _++)
        q = b.childNodes[_], q.nodeType === 3 ? _ += w(q) ? 1 : 0 : l(q, w);
    }, a = o(t, !1);
    t && l(e, E);
  };
  function xe(e) {
    ["id", "name", "placeholder", "required", "aria-label"].forEach((t) => e.removeAttribute(t)), e.setAttribute("readonly", "true"), e.setAttribute("aria-hidden", "true"), e.style.marginTop = `-${c.offsetHeight + parseInt(ne.marginBottom)}px`, e.tabIndex = -1, e.className = g.hint, c.after(e);
  }
  const Se = (e) => {
    const t = c.value;
    if (!t || f(e) === t || // if input string is exactly the same as selectedItem
    ae(f(e)).indexOf(
      ae(t).replace(/\s{2,}/g, " ").trimStart()
    ) !== 0)
      J.value = "";
    else {
      const o = f(e), E = new RegExp(de(n.query), "i");
      let l = E.exec(o);
      r.diacritics && !l && (l = E.exec(X(o))), l && (J.value = t.replace(/\s?$/, "") + o.substring(l[0].length));
    }
  }, F = (e, t) => {
    const o = h.createElement("template");
    return o.innerHTML = t, e.appendChild(o.content), t;
  }, ke = () => {
    setTimeout(() => {
      h.activeElement !== c && A();
    }, 50);
  };
  i.addEventListener("mousedown", function(e) {
    e.stopPropagation(), e.preventDefault();
  });
  const ue = (e) => {
    A(), u.clear(), C && !e && V(C), P = {}, z = {}, T && (T.done = !1);
  }, qe = () => {
    oe(), ue(), H.replaceWith(c.cloneNode());
  };
  return c.addEventListener("keydown", we), c.addEventListener("input", ye), c.addEventListener("blur", ke), c.addEventListener("focus", ve), {
    addToIndex: V,
    reset: ue,
    destroy: qe
    // trie, // trie exposed only for local tests
  };
}
export {
  $e as default
};
